import React, { useEffect, useState } from 'react';

function Loader({ children, shouldLoad }: { children: React.ReactNode; shouldLoad: boolean }) {
  const [load, setLoad] = useState(shouldLoad);

  useEffect(() => {
    if (shouldLoad && !load) {
      setLoad(true);
    }
  }, [shouldLoad]);

  return <>{load && children}</>;
}

export default Loader;
